import axios, { AxiosError } from 'axios';

import { Maintenance } from './maintenance';

export type ModelError = {
  statusCode: string;
  error: string;
  message: string;
  details?: string[];
  maintenance?: Maintenance;
};

export type ClarisApiError = AxiosError<ModelError>;

export const isClarisApiError = (error: unknown): error is ClarisApiError => {
  return axios.isAxiosError(error);
};

/**
 * APIリクエスト前のパラメータバリデーションエラー
 *
 * APIを呼び出す前にパラメータをチェックして、問題があった時に投げる専用のエラーです。
 * JavaScript標準のErrorクラスを継承して、エラーとしての基本機能を受け継ぎつつ、
 * バリデーション専用の追加情報（field, code）を持てるようにしています。
 */
export class ApiValidationError extends Error {
  /**
   * バリデーションエラーを作成します
   *
   * @param message エラーの内容を説明するメッセージ（例：「startDateが指定されていません」）
   * @param field 問題があったフィールド名（例：「startDate」）- 省略可能
   * @param code エラーの種類を表すコード（例：「MISSING_DATE」）- 省略可能
   */
  constructor(message: string, public field?: string, public code?: string) {
    // 親クラス（Error）の初期化を実行
    // これにより、エラーメッセージの保存とスタックトレースの生成が行われる
    super(message);

    // エラーの名前を設定（ログやデバッグ時にエラーの種類を識別するため）
    // デフォルトでは "Error" になるが、"ApiValidationError" に変更
    this.name = 'ApiValidationError';
  }
}
